<script lang="ts">
	import StoriesGrid from '$lib/components/stories-grid.svelte';
	import type { PageData } from './$types';

	let { data } = $props<{ data: PageData }>();

	// Format labels for display
	const labelDisplay = $derived(
		data.selectedLabels.length > 0
			? data.selectedLabels
					.map((label: string) => label.charAt(0).toUpperCase() + label.slice(1))
					.join(', ')
			: 'All Stories'
	);
</script>

<div class="container mx-auto flex flex-col gap-8 px-4 pb-8 pt-4">
	<div>
		<h1 class="text-3xl font-bold md:text-4xl">{labelDisplay}</h1>
		{#if data.selectedLabels.length > 0}
			<p class="mt-2 text-muted-foreground">
				Stories tagged with {#if data.selectedLabels.length > 1}any of
				{/if}
				{data.selectedLabels
					.map((label: string) => `"${label.charAt(0).toUpperCase() + label.slice(1)}"`)
					.join(', ')}
			</p>
		{:else}
			<p class="mt-2 text-muted-foreground">Browse all available stories</p>
		{/if}
	</div>

	<StoriesGrid
		stories={data.label_stories}
		emptyMessage="No stories found with the selected labels."
	/>
</div>
